"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Styles = {
    input: (props) => (0, core_1.css) `
    border-width: 1px;
    border-style: solid;
    border-color: ${styles_scss_1.default.grey};
    ${props.success ? `border-color: ${styles_scss_1.default.success};` : ''}
    ${props.error ? `border-color: ${styles_scss_1.default.errorColor};` : ''}
    &:focus {
      border-color: ${props.error ? styles_scss_1.default.errorColor : styles_scss_1.default.primary};
      outline: none;
    }
    &:focus + label {
      color: ${props.error ? styles_scss_1.default.errorColor : styles_scss_1.default.primary};
    }
    ${props.error && `
      & + label {
        color: ${styles_scss_1.default.errorColor};
      }
    `}
  `,
    label: (props) => (0, core_1.css) `
      color: ${props.isFocus ? styles_scss_1.default.primary : styles_scss_1.default.darkGrey};
      ${props.error ? `color: ${styles_scss_1.default.errorColor}; ` : ''}
  `,
    accessory: (props) => (0, core_1.css) `
    ${props.accessoryPosition === 'right' ? 'right: 10px;' : 'left: 12px;'}
  `
};
exports.default = Styles;
